var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIosPie(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9375 3.19228V13.4579C12.9375 13.6313 12.8203 13.7767 12.6563 13.8188L3.80159 16.097C3.69378 16.1251 3.63284 16.2423 3.67503 16.3501C5.11409 19.9688 8.66722 22.5282 12.8063 22.5001C18.1782 22.4673 22.5 18.1173 22.5 12.7501C22.5 7.4954 18.3469 3.21103 13.1344 3.00946C13.0266 3.00478 12.9375 3.08915 12.9375 3.19228Z",
    fill: "#737A91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 11.2172C1.5 11.2172 1.50938 13.5047 2.2125 15.0187C2.25 15.1031 2.34375 15.1453 2.42812 15.1219L11.5125 12.7922C11.6766 12.75 11.8125 12.5766 11.8125 12.4078V1.6875C11.8125 1.58437 11.7281 1.5 11.625 1.5C4.26562 1.58906 1.5 6.98438 1.5 11.2172Z",
    fill: "#737A91"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosPie);
export default __webpack_public_path__ + "static/media/ios-pie.5648bce7.svg";
export { ForwardRef as ReactComponent };